import slick from "slick-carousel";
import fancybox from "@fancyapps/fancybox";

$(function () {
    /* slider */
    $("#slider").slick({
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 1500,
        arrows: false,
        dots: false,
        centerMode: false,
        fade: true,
    });

    // logos slider
    $('#logos').slick({
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            },
        ]
    });

    /* FANCYBOX */
    $("a.fancybox").fancybox({
        loop: true,
        keyboard: true,
    });
});
